import { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { activityPlanTypes } from '../../store/actions';
import { APP_NAME } from '../../utils/constant';

import ActivityHome from './form/home';

import './activities.scss';

class Activities extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { t } = this.props;
    document.title = `${t('common.activities')} | ${APP_NAME}`;
    try {
      const { activityPlanTypes } = this.props;
      activityPlanTypes();
    } catch (error) {
      console.error('Activities -> componentDidMount -> error', error);
    }
  }

  render() {
    return (
      // <FeatureWrapper
      //   featureName="activities"
      //   children={
      //     <ActivityHome />
      //   }
      //   fallbackComponent={
      //     <UnAuthorizedAccess/>
      //   }
      // />
      <ActivityHome />
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      activityPlanTypes,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Activities));
